import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const BasicValuePage = lazy(() => import('../../pages/BasicValuePage/BasicValuePage'));

const routes = [
  {
    // Sem `requiresOnboardingFleet`: o guia é acessível a qualquer frota, com ou sem 90 dias de
    // contrato. A janela de onboarding decide qual home aparece, não se esta página existe.
    path: Location.BASIC_VALUE,
    team: 'squad-account-experience',
    component: BasicValuePage,
    exact: true,
  },
];

export default routes;
